import { ThemeColorValue } from './derive-theme-color'
import { BrandingImage, PreparedImage } from './prepare-image'

// The branding attributes the editor offers. The endpoint refuses everything an e-commerce does
// not own, and the secondary brand colour is left out because no shopper-facing surface renders
// it — only `use-theme.ts` defines it and only the internal demo form asks for it. Since the
// endpoint writes just what it receives, a secondary already stored by ops stays untouched.
export interface BrandingTheme {
  primary: ThemeColorValue | null
  borderRadius: string
  inputVariant: string
  title: string
  backgroundTextColor: string
  logoHeightDesktop: string
  logoHeightMobile: string
}

export const emptyBrandingTheme: BrandingTheme = {
  primary: null,
  borderRadius: '',
  inputVariant: '',
  title: '',
  backgroundTextColor: '',
  logoHeightDesktop: '',
  logoHeightMobile: ''
}

// The stored image urls, kept out of BrandingTheme because they are not patchable: the endpoint
// refuses them, and an e-commerce sets them by uploading instead. They are read here only so the
// editor can show what is currently in place.
export interface StoredBrandingImages {
  logo: string
  favicon: string
  background: string
}

export const emptyStoredBrandingImages: StoredBrandingImages = {
  logo: '',
  favicon: '',
  background: ''
}

// Images picked in the editor but not uploaded yet, by attribute. Absent means unchanged.
export type PendingBrandingImages = Partial<
  Record<BrandingImage, PreparedImage>
>
